const QuestionJson = {
    title: "Starparty | CyberSpace - Workshop",
    showProgressBar: "bottom",
    showTimerPanel: "top",
    maxTimeToFinishPage: 45,
    maxTimeToFinish: 1500,
    firstPageIsStarted: true,
    startSurveyText: "Start Quiz",
    pages: [
        {
            questions: [
                {
                    type: "html",
                    html: "You have 1 min per question to answer.<br/>Please click on <b>'Start Quiz'</b> button when you are ready."
                },
                {
                    name: "name",
                    type: "text",
                    title: "Please enter your name:",
                    placeHolder: "Your Name",
                    isRequired: true,
                    autoComplete: "name"

                    }
            ]
        }, 
        


                
        { questions: [
            {
            type: "radiogroup",
            name: "q9",
            title: "පෘථීවියේ සිට සූර්යයාට ඇති දුර 150 000 000km (150 × 10^6 km)වේ. තාරකා විද්‍යාවේදී, මෙය දුර මැනීමේ විශේෂ ඒකකයක් ලෙස භාවිතා කරයි. එය හදුන්වනු ලබන්නේ?",
            choices: [ "ආලෝක වර්ෂ ", "නක්ෂත්‍ර ඒකකය ", "පාසෙක් දිග ", "ස්වාඛයිල්ඩ් අරය " ]
            }
            ]
            },

            { questions: [
            {
            type: "radiogroup",
            name: "q8",
            title: "බාහිර ග්‍රහලෝක වලට සාපේක්ෂව, අභ්‍යන්තර ග්‍රහලෝක සතු ලක්ෂණයක් නොවන්නේ?",
            choices: [ "ප්‍රමාණයෙන් කුඩා වීම", "පාෂාණයම මතුපිටක් දැරීම ", "උපග්‍රහයින් කුඩා සංඛ්‍යාවක් තිබීම හෝ නොතිබීම ", "බාහිර ග්‍රහලෝක වලට සාපේක්ෂව අඩු ඝනත්වයක් තිබීම " ]
            }
            ]
            },
            
            { questions: [
            {
            type: "radiogroup",
            name: "q4",
            title: "සෞරග්‍රහ මණ්ඩලයේ උණුසුම් බවින් වඩිම ග්‍රහලොව වන්නෙ?",
            choices: [ "පෘථීවිය", "අඟහරු", "සිකුරු", "බුධ" ]
            }
            ]
            },
            { questions: [
            {
            type: "radiogroup",
            name: "q10",
            title: "සෞරග්‍රහ මණ්ඩලයේ උපත/ සම්භවය පිළිගත් වඩාත් පිළිගත් මතය කුමක්ද?",
            choices: [ "මහා ගැටුම් කල්පිතය ", "නිහාරිකා කල්පිතය ", "කොස්මොසෙයින් වාදය ", "විලයන කල්පිතය " ]
            }
            ]
            },
            { questions: [
            {
            type: "radiogroup",
            name: "q7",
            title: "ගැලිලියානු චන්ද්‍රයන් පමනක් ඇති පිළිතුර වන්නේ?",
            choices: [ "සඳ, ගැනිමීඩ්, ටයිටන්, චාරොන්", "අයෝ, සඳ, ටයිටන්, කැලිස්ටෝ ", "සඳ, යුරෝපා, ටයිටන්, මිරැන්ඩා ", "ගැනිමීඩ්, යුරෝපා, අයෝ, කැලිස්ටෝ " ]
            }
            ]
            },
            { questions: [
            {
            type: "radiogroup",
            name: "q3",
            title: "අපට ළඟම තාරකාව කුමක්ද?",
            choices: [ "ප්‍රොක්සිමා සෙන්ටොරි", "සිරියස්", "සුර්යයා", "වේගා" ]
            }
            ]
            },
            
            { questions: [
            {
            type: "radiogroup",
            name: "q17",
            title: "පහත සඳහන් ආකාශ වස්තූන් සහ ඒවා පිහිටි තාරකා රාශි වැරදි ලෙස දක්වා ඇති පිළිතුර කුමක්ද?",
            choices: [ "ඔරායන් නිහාරිකාව - ඔරායන් තාරකා රාශිය ", "සීරියස් තාරකාව - මහ බල්ලා තාරකා රාශිය ", "හත්දින්න තරු පොකුර - වෘෂභ තාරකා රාශිය ", " බීට්ල්ජූස් තාරකාව - සිංහ තාරකා රාශිය " ]
            }
            ]
            },
            
            { questions: [
            {
            type: "radiogroup",
            name: "q1",
            title: "සෞරග්‍රහ මණ්ඩලයේ ප්‍රධාන ග්‍රහලෝක ගණන වන්නේ?",
            choices: [ "8 කි", "9 කි", "10 කි", "12 කි" ]
            }
            ]
            },

            { questions: [
            {
            type: "radiogroup",
            name: "q5",
            title: "පහත උපග්‍රහයින් අතරින්, වැඩිම ගිනිකඳු ක්‍රියාකාරීත්වය ඇති උපග්‍රහයා වන්නේ?",
            choices: [ "ගැනිමීඩ්", "සඳ", "කැලිස්ටෝ", "අයෝ" ]
            }
            ]
            },

            { questions: [
            {
            type: "radiogroup",
            name: "q6",
            title: "අප සෞරග්‍රහ මණ්ඩලයේ පිහිටි මන්දාකිණිය වන්නේ?",
            choices: [ "ඇන්ඩ්‍රොමිඩා මන්දාකිණිය", "ක්ෂීරපථය මන්දාකිණිය", "මැගලන් වලාව මන්දාකිණිය", "වර්පූල් මන්දාකිණිය" ]
            }
            ]
            },
            { questions: [
                {
                type: "radiogroup",
                name: "q18",
                title: "පළමුව සොයාගත් වාමන ග්‍රහලෝකය",
                choices: [ "සෙරස්", "චාරොන්", "ප්ලූටෝ", "ඒරිස්" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q11",
                title: "පළමුවරට සූර්ය කේන්ද්‍රවාදය පිළිබඳ අදහස හදුන්වා දුන් තාරකා විද්‍යාඥයා?",
                choices: [ "ඇරිස්ටාකස්", "හිපාකස්", "තේල්ස්", "ජොහැන්නස් කෙප්ලර්" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q2",
                title: "ආකාශ වස්තූන් යනු භෞතිකව පවතින දෑ මිස දෙවියන් නොවන බවට ස්ංකල්පයක් මුලින් ම ඉදිරිපත් කළේ?",
                choices: [ "තෙලෙස් විසිනී", "ප්ලෙටෝ විසිනී", "ඇරිස්ටාකස් විසිනී", "ඇරිස්ටොටල් විසිනී" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q14",
                title: "සූර්යයා වටා ග්‍රහලෝක ගමන් කිරීමට හේතුව ඉදිරිපත් කළ විද්‍යාඥයා?",
                choices: [ "නිකලස් කොපර්නිකස්", "ජොහැන්නස් කෙප්ලර්", "සර් අයිසැක් නිව්ටන්", "ටයිකෝ බ්‍රාහේ" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q15",
                title: "පූර්වායනය සොයාගත් පුද්ගලයා?",
                choices: [ "තේල්ස්", "එරතොස්තනීස්", "ඇරිස්ටාකස්", "හිපාකස්" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q12",
                title: "ඉපැරණි ඊජිප්තු ශිෂ්ටාචාරයේ දී , සූර්යයා හෙවත් හිරු දෙවියන් හැදින්වුයේ?",
                choices: [ "ඇපලෝ යනුවෙනි", "වීනස් යනුවෙනි", "රා යනුවෙනි", "පොසයිඩන් යනුවෙනි" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q16",
                title: "පෘථිවිය ගෝලාකාර බව මුලින් ම ගණිතය සහ තාරකා විද්‍යාව ඇසුරින් තහවුරු කල දාර්ශනිකයා සහ මුල් ම වරට දුරේක්ෂයක් නිපදූ පුද්ගලයා පිළිවළින් අඩංගු වන වරණය තෝරන්න",
                choices: [ "පයිතගොරස් සහ ටොලමි", "පයිතගොරස් සහ හැන්ස් ලිපර්ෂි", "හිපාකස් සහ හැන්ස් ලිපර්ෂි", "ඇරිස්ටොටල් සහ ගැලීලියො ගැලලී" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q19",
                title: "පෘථිවියේ අරය විද්‍යාත්මක ක්‍රම භාවිතයෙන් ගණනය කල පුද්ගලයා ?",
                choices: [ "ටයිකෝ බ්‍රාහේ", "හිපාකස්", "එරතොස්තනීස්", "ජොහැන්නස් කෙප්ලර්" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q13",
                title: "මේ අතරින් යුරේනස් ග්‍රහලොව සොයාගන්නා ලද විද්‍යාඟයා වන්නෙ",
                choices: [ "විලියම් හර්ෂල්", " නිකලස් කොපර්නිකස්", "ටයිකෝ බ්‍රාහේ", "ගැලීලියෝ ගැලීලී" ]
                }
                ]
                },
                { questions: [
                {
                type: "radiogroup",
                name: "q20",
                title: "ආකාශ වස්තු නිරීක්ෂණය කර,ඒ ඇසුරින් මුල් ම ලිඛිත වාර්තා සටහන් කර තබාගත්තා යැයි සැලකෙන්නේ කුමන ශිෂටාචාරයක වැසියන් විසින් ද?",
                choices: [ "ග්‍රීක ශිෂ්ටාචාරය", "බැබිලෝනියානු ශිෂ්ටාචාරය", "ඇසටෙක් ශිෂ්ටාචාරය", "ඉන්දු නිම්න ශිෂ්ටාචාරය" ]
                }
                ]
                },




                    







        
            ],
        
        
        
    
    
    completedHtml: "<h4>Thank you for participating in Starparty|Cyberspace</h4>"

}

export default QuestionJson;